import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/leave-rules', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/leave-rules', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employeeType = (options = {}) => {
  return httpClient
    .get('/api/leave-rules/employee-types', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const leaveType = (options = {}) => {
  return httpClient
    .get('/api/leave-rules/leave-types', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, employeeType, leaveType }
